import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function ListPagination({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (!Number.isFinite(pageCount) || pageCount <= 1) {
    return null;
  }

  return (
    <nav aria-label="Seiten" className="flex items-center justify-between gap-3 pt-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeftIcon aria-hidden />
        Zurück
      </Button>
      <span className="text-sm text-muted-foreground">
        Seite {page} von {pageCount}
      </span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
      >
        Weiter
        <ChevronRightIcon aria-hidden />
      </Button>
    </nav>
  );
}
